import "../../styles/all.css";
import "./three.css";
import aboutimg from "../../img/about-img (1).png";
import aboutbg from "../../img/about-img-bg.png";
import { useTranslation } from "react-i18next";

function Three() {
  const { t } = useTranslation();

  return (
    <>
      <div className="three" data-aos="flip-right">
        {/* one section */}
        <div className="frist">
          <div className="left">
            <div className="info">
              <h1>{t("about.title")}</h1>
              <span>{t("about.experience")}</span>
              <p>{t("about.description")}</p>
            </div>
            <div className="flex">
              <div className="second">
                <div className="icon">
                  <i className="fa-solid fa-headset"></i>
                </div>
                <div className="text">
                  <h4>{t("about.support.title")}</h4>
                  <p>{t("about.support.text")}</p>
                </div>
              </div>
              <div className="second">
                <div className="icon">
                  <i className="fa-solid fa-gears"></i>
                </div>
                <div className="text">
                  <h4>{t("about.solutions.title")}</h4>
                  <p>{t("about.solutions.text")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="image">
              <img src={aboutimg} alt="" />
              <img src={aboutbg} className="background" alt="" />
            </div>
          </div>
        </div>

        {/* two section */}
        <div className="frist">
          <div className="right">
            <div className="image">
              <img src={aboutimg} alt="" />
              <img src={aboutbg} className="background" alt="" />
            </div>
          </div>
          <div className="left">
            <div className="info">
              <h1>{t("vision.title")}</h1>
              <span>{t("vision.subtitle")}</span>
              <p>{t("vision.description")}</p>
            </div>
            <div className="flex">
              <div className="second">
                <div className="icon">
                  <i className="fa-solid fa-headset"></i>
                </div>
                <div className="text">
                  <h4>{t("vision.innovation.title")}</h4>
                  <p>{t("vision.innovation.text")}</p>
                </div>
              </div>
              <div className="second">
                <div className="icon">
                  <i className="fa-solid fa-gears"></i>
                </div>
                <div className="text">
                  <h4>{t("vision.partnership.title")}</h4>
                  <p>{t("vision.partnership.text")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* three section */}
        <div className="frist">
          <div className="left">
            <div className="info">
              <h1>{t("vision.title")}</h1>
              <span>{t("vision.subtitle")}</span>
              <p>{t("vision.description")}</p>
            </div>
            <div className="flex">
              <div className="second">
                <div className="icon">
                  <i className="fa-solid fa-headset"></i>
                </div>
                <div className="text">
                  <h4>{t("vision.innovation.title")}</h4>
                  <p>{t("vision.innovation.text")}</p>
                </div>
              </div>
              <div className="second">
                <div className="icon">
                  <i className="fa-solid fa-gears"></i>
                </div>
                <div className="text">
                  <h4>{t("vision.partnership.title")}</h4>
                  <p>{t("vision.partnership.text")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="image">
              <img src={aboutimg} alt="" />
              <img src={aboutbg} className="background" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Three;